/**
 * <Field> — label + control + error/help layout.
 *
 * Composes existing input primitives (RowInput, ValidatedInput, EmailInputWithDomain,
 * SmartStateSelect, NpiLookup, etc.) — it does NOT replace them. Pass them as children.
 *
 * Props:
 *  - label    : visible label text (string)
 *  - htmlFor  : optional id of the control for label association
 *  - required : draws an asterisk on the label
 *  - error    : error message string OR react-hook-form error object ({ message })
 *  - help     : help text shown when no error
 *  - children : the actual input element
 */
export default function Field({
  label,
  htmlFor,
  required,
  error,
  help,
  children,
  className,
}) {
  const errMsg =
    typeof error === 'string' ? error : error && error.message ? error.message : null
  const cls = 'form-field' + (errMsg ? ' has-error' : '') + (className ? ' ' + className : '')
  return (
    <div className={cls}>
      {label && (
        <label className="form-field-label" htmlFor={htmlFor}>
          {label}
          {required && <span className="form-field-required" aria-hidden="true"> *</span>}
        </label>
      )}
      {children}
      {errMsg ? (
        <div className="form-field-error">{errMsg}</div>
      ) : help ? (
        <div className="form-field-help">{help}</div>
      ) : null}
    </div>
  )
}
